import template from './ko-numeric-range.html';
import ValueRange from '../../models/ValueRange.js';
import './ko-numeric-range.css';

class NumericRangeVM
{
	constructor(params)
	{
		this.params = params;

		this.value = ko_helper.safe_observable(params?.value, '[,)');

		this.value_range = new ValueRange(this.value, {
			serialize_function: (val) =>
			{
				if (!val) return '';
				return parseFloat(val).toString();
			},
			deserialize_function: (val) =>
			{
				if (!val) return '';
				return parseFloat(val);
			}
		});

		this.from_label = ko.pureComputed(() => this.value_range.from_unbounded() === true ? '-' : (this.value_range.from_inclusive() ? '[' : '('));
		this.to_label = ko.pureComputed(() => this.value_range.to_unbounded() === true ? '-' : (this.value_range.to_inclusive() ? ']' : ')'));
		this.from_tooltip = ko.pureComputed(() => this.value_range.from_unbounded() === true ? 'Unbounded' : (this.value_range.from_inclusive() ? 'Inclusive' : 'Exclusive'));
		this.to_tooltip = ko.pureComputed(() => this.value_range.to_unbounded() === true ? 'Unbounded' : (this.value_range.to_inclusive() ? 'Inclusive' : 'Exclusive'));

	}
}

export default {
	name: 'ko-numeric-range',
	viewModel: NumericRangeVM,
	module_type: 'ko',
	template: template
};
